export const PROFILE_REASON_CODES = ['profile_new_function', 'profile_least_privilege', 'profile_copy', 'profile_correction', 'profile_retire', 'profile_other'];
const enc = encodeURIComponent;
export class AccessProfilesApi {
    client;
    constructor(client) {
        this.client = client;
    }
    catalog() {
        return this.client.request({ method: 'GET', path: '/v1/admin/access-profiles/catalog', auth: true });
    }
    list(includeRetired = false) {
        return this.client.request({ method: 'GET', path: `/v1/admin/access-profiles${includeRetired ? '?retired=1' : ''}`, auth: true });
    }
    get(id) {
        return this.client.request({ method: 'GET', path: `/v1/admin/access-profiles/${enc(id)}`, auth: true });
    }
    /** 201 when the first version is approved at once; 202 `fourEyes: true` when it carries admin authority and waits for a second operator. */
    create(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/access-profiles', body: input, auth: true });
    }
    /** A new version of the words / home screen (409 while another version is pending). */
    propose(id, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/access-profiles/${enc(id)}/versions`, body: input, auth: true });
    }
    copy(id, name, note) {
        return this.client.request({ method: 'POST', path: `/v1/admin/access-profiles/${enc(id)}/copy`, body: { name, ...(note !== undefined && note.trim() !== '' ? { note: note.trim() } : {}) }, auth: true });
    }
    /** approve / reject (a DIFFERENT operator) or withdraw (the proposer). */
    decide(id, version, action, note) {
        const body = note !== undefined && note.trim() !== '' ? { note: note.trim() } : {};
        return this.client.request({ method: 'POST', path: `/v1/admin/access-profiles/${enc(id)}/versions/${String(version)}/${action}`, body, auth: true });
    }
    retire(id, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/admin/access-profiles/${enc(id)}/retire`, body: { reasonCode }, auth: true });
    }
}
//# sourceMappingURL=access-profiles.js.map